import { useDataRequestContext } from '@vivli/features/data-requests/infrastructure/context';
import { DataRequestViewComponent } from '../data-request-view/data-request-view.component';
import { useDataRequestPermissionsContext } from '@vivli/core/infrastructure/context';

export const DataRequestPrintViewComponent = () => {
    const { shouldHideReviewers } = useDataRequestPermissionsContext();
    const { dataRequest, organizations, includeRiskScore, handleSavePdfVersion, isSavingDataRequest } = useDataRequestContext();

    return (
        <DataRequestViewComponent
            dataRequest={dataRequest as any}
            showAimlQuestions={true}
            includeRiskScore={includeRiskScore}
            hideReviewers={shouldHideReviewers(dataRequest, organizations)}
            handleSavePdfVersion={handleSavePdfVersion}
            isSavingDataRequestVersion={isSavingDataRequest}
        />
    );
};
